import styled from 'styled-components';
import BackgroundWhite from '@assets/images/colors/background_white.svg';
import BackgroundBlack from '@assets/images/colors/background_black.svg';

export const BackgroundWhiteImg = styled(BackgroundWhite)`
`;

export const BackgroundBlackImg = styled(BackgroundBlack)`
`;